import { useEffect, useState } from "react";
import { TEMPLATE_ID } from "../../api/constants";
import FansUnitedFantasyPlayComponent from "../../external/play/fantasy-play-component";
import useFansUnitedSDK from "../../hooks/useFansUnitedSDK";
import styles from "./PredictionsFragment.module.css";
import Welcome from "./components/Welcome/Welcome";
import { getUserCountry } from "../../redux/user/selectors";
import { useSelector } from "react-redux";

// LocalStorage key for tracking if user has played
const HAS_PLAYED_KEY = "fantasy_football_has_played";

const PredictionsFragment = () => {
	const [hasUserPlayed, setHasUserPlayed] = useState(null);
	const fansUnitedSDK = useFansUnitedSDK();
	const userCountry = useSelector(getUserCountry);

	// Check both API response and localStorage to determine if we should show the play screen
	const showPlayScreen = hasUserPlayed === true || localStorage.getItem(HAS_PLAYED_KEY) === "true";

	useEffect(() => {
		// Check localStorage first for quick UI response
		const hasPlayedFromStorage = localStorage.getItem(HAS_PLAYED_KEY) === "true";
		if (hasPlayedFromStorage) {
			setHasUserPlayed(true);
		}

		// Then fetch from API for the latest status
		if (fansUnitedSDK) {
			fetchUserPicks();
		}
	}, [fansUnitedSDK]);

	const fetchUserPicks = async () => {
		console.log("Fetching user picks...");
		try {
			const userPicksFromAPI = await fansUnitedSDK.loyalty.getOwnRankings({ leaderboardIds: [TEMPLATE_ID], rankType: "template" });
			console.log("User picks:", userPicksFromAPI);
			const hasPlayed = userPicksFromAPI.data.length > 0;

			// Update state and localStorage if user has played
			if (hasPlayed) {
				setHasUserPlayed(true);
				localStorage.setItem(HAS_PLAYED_KEY, "true");
			} else {
				setHasUserPlayed(false);
			}
		} catch (error) {
			console.error("Error fetching user picks:", error);
			setHasUserPlayed(false);
		}
	};

	// Handle the play button click from Welcome screen
	const handlePlayClick = () => {
		// Mark that the user has seen the welcome screen
		localStorage.setItem(HAS_PLAYED_KEY, "true");
		setHasUserPlayed(true);
	};

	return (
		<>
			{!showPlayScreen && <Welcome onPlayClick={handlePlayClick} />}
			{showPlayScreen && (
				<div className={styles.container}>
					<FansUnitedFantasyPlayComponent fansUnitedSDK={fansUnitedSDK} gameTemplateId={TEMPLATE_ID} country={userCountry} />
				</div>
			)}
		</>
	);
};

export default PredictionsFragment;
